'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _LegacyInlineCart = require('components/InlineCart/LegacyInlineCart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleCloseInlineCartClick = function handleCloseInlineCartClick() {
  PubSub.publish(_Constants2.default.closeInlineCart, {});
};

var handleToggleInlineCartClick = function handleToggleInlineCartClick() {
  PubSub.publish(_Constants2.default.toggleInlineCart, {});

  $('.header-mobile-category').each(function (index) {
    var resetText = $(this).attr('data-trigger-menu');

    $(this).removeClass('is-active').find('p').text(resetText);
    $('.js-mobile-nav').removeClass('active');
  });
};

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.toggleInlineCart).on('click', handleToggleInlineCartClick);
  $(_Dom2.default.inlineCart).on('click', _Dom2.default.closeInlineCart, handleCloseInlineCartClick);

  $(document).on('click', '[data-toggle-inline-signin]', function (_ref) {
    var self = _ref.currentTarget;

    _LegacyInlineCart.ViewController.setState({
      account: 'login',
      checkout: ''
    });
  });

  $(document).on('click', '[data-toggle-inline-create-account], [data-inline-register-btn]', function (_ref2) {
    var self = _ref2.currentTarget;

    _LegacyInlineCart.ViewController.setState({
      account: 'create',
      checkout: ''
    });
  });

  $(document).on('click', '[data-forgot-password-button]', function (_ref3) {
    var self = _ref3.currentTarget;

    _LegacyInlineCart.ViewController.setState({
      account: 'reset_password',
      checkout: ''
    });
  });

  $(document).on('click', '[data-inline-login-btn]', function (_ref4) {
    var self = _ref4.currentTarget;

    _LegacyInlineCart.ViewController.setState({
      account: 'login',
      checkout: ''
    });
  });

  $('[data-checkout-path]').on('change', function (_ref5) {
    var self = _ref5.currentTarget;

    var path = $(self).attr('value');

    _LegacyInlineCart.ViewController.setState({
      account: '',
      checkout: path
    });
  });

  $('.main-cart-block [data-line-item-remove-btn]').on('click', function (_ref6) {
    var self = _ref6.currentTarget;

    $(document).on('cart.requestComplete', function () {
      location.reload();
    });
  });

  // $('[data-guest-checkout-link]').on('click', InlineCart.redirectToCheckout);

  _LegacyInlineCart.ViewController._updateUI();
};